import { useList } from 'storfox-api-hooks'

import * as API from '../constants/api'

function useOrderingList () {
  return useList(API.ORDERING_LIST, {}, false)
}

export default useOrderingList
